import React from 'react';
import { SubmitError } from 'Components/Fields/SubmitError';
import { SubmitButton } from 'Components/Fields/Buttons';
import { compareToPassword, passStrength, password, requiredPassword } from 'Utils/FormValidation';
import { useForm } from 'Hooks/useForm';
import { FormField } from 'Components/HookFormFields/FormField';
import 'Components/HookFormFields/PasswordField.css';
import './ResetPasswordForm.css';
import { Link } from 'react-router-dom';
import { useStore } from 'Hooks/useStore';

const ResetPasswordForm = ({ onFormSubmit }) => {
  const formName = 'resetPasswordForm';
  const routes = useStore('appConfig.routes');

  const { formFieldProps, submitting, submitDisabled, formError, handleSubmit } = useForm({
    onFormSubmit,
    formName,
  });

  const renderTryAgain = formError?.message === 'Invalid token';

  return (
    <form onSubmit={(event) => handleSubmit(event)} className={formName}>
      <FormField
        name="newPass"
        label="New Password (6 character min)"
        component="PasswordField"
        validate={[requiredPassword, password]}
        warn={passStrength}
        autofocus
        {...formFieldProps}
      />
      <FormField
        name="confirmPass"
        label="Confirm New Password"
        component="PasswordField"
        validate={[requiredPassword, password, compareToPassword]}
        autoValidate={true}
        {...formFieldProps}
      />
      {renderTryAgain ? (
        <p className="tryAgainError">
          Your reset password link has expired, <Link to={routes.resetByEmail}>please try again</Link>
        </p>
      ) : (
        <SubmitError error={formError} formName={formName} />
      )}
      <SubmitButton text="Reset Password" isDisabled={submitting || submitDisabled} />
    </form>
  );
};

export default ResetPasswordForm;
